import { combineReducers, configureStore } from "@reduxjs/toolkit";

import { persistReducer, persistStore } from "redux-persist";
import UserSlice from "./features/user/UserSlice";
import FileSlice from "./features/file/FileSlice";

import sessionStorage from "redux-persist/lib/storage/session";
import { setAxiosDispatch } from "./util/config/axiosConfig";
import WalletSlice from "./features/wallet/WalletSlice";
import studioSlice from "./features/studio-controller/StudioSlice"

const persitConfig = {
  key: "root",
  version: 1,
  storage: sessionStorage,
};

const reducer = combineReducers({
  user: UserSlice,
  file: FileSlice,
  wallet: WalletSlice,
  studio: studioSlice
});
const persistedReducer = persistReducer(persitConfig, reducer);
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});
setAxiosDispatch(store.dispatch);
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
